export default __webpack_public_path__ + "static/media/products-carrousel.9516afb0.svg";